let _pendingFullscreen = false;

const _tryFullscreen = () => {
  const el = document.documentElement;
  try {
    if (el.requestFullscreen) {
      return el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
      return Promise.resolve();
    }
  } catch (_) {}
  return Promise.resolve();
};

const _isInteractive = (target) =>
  !!target?.closest('button, a, input, select, textarea, [role="button"]');

export const ensureFullscreen = () => {
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return;
  if (document.fullscreenElement) return;

  // Always try immediately — works when user gesture is active or browser is permissive
  // (e.g. visibilitychange, file input change). If the browser rejects it,
  // fall back to the next user interaction via deferred listener.
  _tryFullscreen().catch(() => {
    if (_pendingFullscreen) return;
    _pendingFullscreen = true;

    const clickHandler = (e) => {
      // If the user clicked a button/link, don't enter fullscreen during that action —
      // it would block window.open() or cover modals with the fullscreen notification.
      // Re-register and wait for the next interaction instead.
      if (_isInteractive(e?.target)) {
        document.removeEventListener("keydown", keydownHandler, true);
        document.addEventListener("click", clickHandler, { capture: true, once: true });
        document.addEventListener("keydown", keydownHandler, { capture: true, once: true });
        return;
      }
      _pendingFullscreen = false;
      document.removeEventListener("keydown", keydownHandler, true);
      if (!document.fullscreenElement) _tryFullscreen().catch(() => {});
    };

    const keydownHandler = () => {
      _pendingFullscreen = false;
      document.removeEventListener("click", clickHandler, true);
      if (!document.fullscreenElement) _tryFullscreen().catch(() => {});
    };

    document.addEventListener("click", clickHandler, { capture: true, once: true });
    document.addEventListener("keydown", keydownHandler, { capture: true, once: true });
  });
};
